<template>
  <div>
    <div align="left" class="mt-4">
      <h4 class="h5 mb-3 text-primary font-weight-bold">Donasi</h4>
    </div>
    <br />
    <b-row>
      <b-col md="8">
        <b-card class="text-left">
          <h5 class="font-weight-bold text-primary">Create New</h5>
          <br />
          <br />
          <b-row>
            <b-col>
              <b-row>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    class="required"
                    label-class="control-label"
                    label="Code Donation"
                    label-for="input-1"
                  >
                    <input
                      id="input-1"
                      type="text"
                      class="form-control"
                      v-validate="'required|max:25'"
                      name="code"
                      data-vv-as="Code Donation"
                      v-model="code"
                      placeholder="Code"
                    />
                    <b-form-invalid-feedback id="input-code-feedback">{{ veeErrors.first('code') }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    class="required"
                    label-class="control-label"
                    label="Title Bahasa"
                    label-for="input-1"
                  >
                    <input
                      id="input-1"
                      type="text"
                      class="form-control"
                      v-validate="'required|max:25'"
                      name="title_id"
                      data-vv-as="Title Bahasa"
                      v-model="title_id"
                      placeholder="Title"
                    />
                    <b-form-invalid-feedback
                      id="input-title_id-feedback"
                    >{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    class="required"
                    label-class="control-label"
                    label="Title English"
                    label-for="input-1"
                  >
                    <input
                      id="input-1"
                      type="text"
                      class="form-control"
                      v-validate="'required|max:25'"
                      name="title_en"
                      data-vv-as="Title English"
                      v-model="title_en"
                      placeholder="Title"
                    />
                    <b-form-invalid-feedback
                      id="input-title_en-feedback"
                    >{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    class="required"
                    label-class="control-label"
                    label="Description Bahasa"
                    label-for="input-1"
                  >
                    <ckeditor
                      :editor="editor"
                      :config="editorConfig"
                      v-model="description_id"
                      tag-name="textarea"
                      placeholder="Description Bahasa"
                      v-validate="'required'"
                      name="description_id"
                      data-vv-as="Description English"
                      class="form-control"
                    ></ckeditor>
                    <p
                      class="text-danger"
                      style="width:100%;margin-top:.25rem;font-size: 80%;"
                    >{{ veeErrors.first('description_id') }}</p>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    class="required"
                    label-class="control-label"
                    label="Description English"
                    label-for="input-1"
                  >
                    <ckeditor
                      :editor="editor"
                      :config="editorConfig"
                      v-model="description_en"
                      tag-name="textarea"
                      placeholder="Description English"
                      v-validate="'required'"
                      name="description_en"
                      data-vv-as="Description English"
                      class="form-control"
                    ></ckeditor>
                    <p
                      class="text-danger"
                      style="width:100%;margin-top:.25rem;font-size: 80%;"
                    >{{ veeErrors.first('description_en') }}</p>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="input-group-1"
                    class="required"
                    label-class="control-label"
                    label="Donasion Amount"
                    label-for="input-1"
                  >
                    <b-input-group>
                      <template v-slot:prepend>
                        <b-input-group-text>Rp.</b-input-group-text>
                      </template>
                      <input
                        type="text"
                        v-model="donasi"
                        v-validate="'required|numeric'"
                        name="donasi"
                        data-vv-as="Donation Amount"
                        tag-name="textarea"
                        placeholder="Enter donation amount here"
                        class="form-control"
                      />
                    </b-input-group>

                    <p
                      class="text-danger"
                      style="width:100%;margin-top:.25rem;font-size: 80%;"
                    >{{ veeErrors.first('donasi') }}</p>
                  </b-form-group>
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col>
                  <b-form-group id="fieldset-1" label="Start Date" label-for="input-1">
                    <b-row class="m-0">
                      <b-col
                        class="pr-0 pt-1 form-control img-calender-select border-right-0"
                        md="2"
                      >
                        <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                      </b-col>
                      <b-col class="px-0">
                        <datepicker
                          input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                          placeholder="Select Date"
                          v-model="period_start"
                          :format="customFormatter"
                          :disabledDates="disabledDates"
                        ></datepicker>
                      </b-col>
                      <b-col align="left" md="1" class="px-0">
                        <b-col
                          align="left"
                          class="pt-1 px-4 form-control del-calender-select border-left-0"
                          md="2"
                        >
                          <b-row align="left" class="pt-1">
                            <b-col>
                              <b-link @click="resetStardate" style="text-decoration:none">
                                <i class="text-danger fas fa-times"></i>
                              </b-link>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="fieldset-1" label="End Date" label-for="input-1">
                    <b-row class="m-0">
                      <b-col
                        class="pr-0 pt-1 form-control img-calender-select border-right-0"
                        md="2"
                      >
                        <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                      </b-col>
                      <b-col class="px-0">
                        <datepicker
                          input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                          placeholder="Select Date"
                          v-model="period_end"
                          :format="customFormatter"
                          :disabledDates="disabledDates"
                        ></datepicker>
                      </b-col>
                      <b-col align="left" md="1" class="px-0">
                        <b-col
                          align="left"
                          class="pt-1 px-4 form-control del-calender-select border-left-0"
                          md="2"
                        >
                          <b-row align="left" class="pt-1">
                            <b-col>
                              <b-link @click="resetEnddate" style="text-decoration:none">
                                <i class="text-danger fas fa-times"></i>
                              </b-link>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>
                    </b-row>
                    <br />
                    <b-row></b-row>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-checkbox
                  id="is_highlight"
                  v-model="is_highlight"
                  name="is_highlight"
                  value="true"
                  unchecked-value="false"
                  >Set as a Highlight Donasi</b-form-checkbox>
                </b-col>
              </b-row>
              <br />
              <b-row class="text-right">
                <b-col>
                  <b-button
                    variant="primary"
                    @click="post()"
                    :disabled="loading"
                    class="mr-5"
                  >Create</b-button>
                  <router-link :to="{name: 'Donasi'}">
                    <b-button variant="outline-secondary">Cancel</b-button>
                  </router-link>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      loading: false,
      selected: 'first',
      checked: false,
      modalShow: false,
      file: '',
      widthImage: null,
      heightImage: null,
      url: '',
      title_id: '',
      title_en: '',
      donasi: '',
      period_start: '',
      period_end: '',
      is_always_active: false,
      is_highlight: false,
      counthighlight: null,
      slide_screen: [],
      status: [
        { text: 'Active', value: 'first' },
        { text: 'Inactive', value: 'second' },
      ],
      button: [
        { text: 'No', value: 'first' },
        { text: 'Yes', value: 'second' },
      ],
      options2: [
        { text: 'Yes', value: 'first' },
        { text: 'No', value: 'second' },
      ],
      disabledDates: {
        to: new Date(Date.now() - 8672000),
      },
    };
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    resetStardate() {
      this.period_start = '';
    },
    resetEnddate() {
      this.period_end = '';
    },
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const formData = new FormData();

          formData.append('code', this.code);
          formData.append('title_id', this.title_id);
          formData.append('title_en', this.title_en);
          formData.append('description_id', this.description_id);
          formData.append('description_en', this.description_en);
          formData.append('amount', this.donasi);
          formData.append('is_highlight', this.is_highlight);
          if (this.period_start != '' && this.period_end == '') {
            const start = this.period_start.toJSON().slice(0, 10);
            formData.append('period_start', start);
            formData.append('period_end', this.period_end);
          }
          if (this.period_end != '' && this.period_start == '') {
            const end = this.period_end.toJSON().slice(0, 10);
            formData.append('period_start', this.period_start);
            formData.append('period_end', end);
          }
          if (this.period_start != '' && this.period_end != '') {
            const start = this.period_start.toJSON().slice(0, 10);
            const end = this.period_end.toJSON().slice(0, 10);

            formData.append('period_start', start);
            formData.append('period_end', end);
          }
          if (this.period_start == '' && this.period_end == '') {
            formData.append('period_start', this.period_start);
            formData.append('period_end', this.period_end);
          }

          this.loading = true;
          this.$store
            .dispatch('DonasiModule/postDonasi', formData)
            .then((response) => {
              this.loading = false;
              this.$router.push({ name: 'Donasi' });
              this.$swal({
                type: 'success',
                title: 'Your work has been saved',
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.serverError = error.response.data;
              this.$swal({
                type: 'error',
                title: 'Oops...',
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(error);
            });
        } else {
          this.$swal('ERROR!', 'Your file cant be submit.', 'warning');
        }
      });
    },
  },
};
</script>

<style>
</style>
